"use client";

import React, { createContext, useState, useContext } from 'react';

const EventStorageContext = createContext();

export const EventStorageProvider = ({ children }) => {
  const [eventsStored, setEventsStored] = useState(false);

  return (
    <EventStorageContext.Provider value={{ eventsStored, setEventsStored }}>
      {children}
    </EventStorageContext.Provider>
  );
};

export const useEventStorage = () => {
  const context = useContext(EventStorageContext);
  if (context === undefined) {
    throw new Error('useEventStorage must be used within an EventStorageProvider');
  }
  return context;
};
